import React, { useContext } from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import { Link } from 'react-router-dom';
import ProfileContext from '../context/ProfileContext';
import ActiveMembershipsPanel from './ActiveMembershipsPanel';

const Home = () => {
  const { profile } = useContext(ProfileContext);

  return (
    <Box sx={{ bgcolor: '#F5F7FB', minHeight: '100vh', py: { xs: 3, md: 5 } }}>
      <Container maxWidth="xl">
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 5,
            p: { xs: 3, md: 5 },
            mb: 4,
            color: '#fff',
            background: 'linear-gradient(125deg, #000449 0%, #101A63 62%, #F95A00 150%)',
            boxShadow: '0 22px 55px rgba(0, 4, 73, 0.2)',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 280,
              height: 280,
              borderRadius: '50%',
              bgcolor: 'rgba(249,90,0,0.22)',
              right: -90,
              top: -150,
            }}
          />
          <Stack spacing={2} sx={{ position: 'relative', maxWidth: 760 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <AllInclusiveRoundedIcon sx={{ color: '#FF8A45', fontSize: 34 }} />
              <Typography variant="overline" fontWeight={900} letterSpacing={1.4}>
                Tableau de bord Gyma
              </Typography>
            </Box>
            <Typography variant="h3" fontWeight={950} sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
              Bonjour{profile?.name ? `, ${profile.name}` : ''}
            </Typography>
            <Typography sx={{ opacity: 0.82, fontSize: { xs: '1rem', md: '1.1rem' } }}>
              Retrouvez les abonnements réellement payés, contrôlez les codes d'accès et suivez les échéances depuis un seul écran.
            </Typography>
            <Box>
              <Button
                component={Link}
                to="/memberships"
                variant="contained"
                endIcon={<ArrowForwardRoundedIcon />}
                sx={{
                  mt: 1,
                  bgcolor: '#F95A00',
                  borderRadius: 2.5,
                  px: 2.5,
                  py: 1.2,
                  fontWeight: 800,
                  '&:hover': { bgcolor: '#E65100' },
                }}
              >
                Gérer les offres d'abonnement
              </Button>
            </Box>
          </Stack>
        </Box>

        <ActiveMembershipsPanel />
      </Container>
    </Box>
  );
};

export default Home;
